<template>
    <div class="view view-analytics-practice">
        <HeaderAnalyticsPractice />
        <HeadingAnalyticsPractice
            headingText="Pratik Rekoru:"
            :highlightedText="highlightedTextPracticeStreak"
            :descText="descTextPracticeStreak" />
        <AnalyticsPracticeStreak />
        <FilterbarAnalyticsPracticeStreak />
        <AnalyticsNumPracticeComparative />
        <HeadingAnalyticsPractice
            headingText="Pratik Sayısı:"
            :highlightedText="highlightedTextNumPracticeMode"
            :descText="descTextNumPracticeMode" />
        <FilterbarAnalyticsNumPracticeMode />
        <AnalyticsNumPracticeMode />
        <ChartAnalyticsNumPractice />
        <HeadingAnalyticsPractice
            headingText="Pratik Süresi:"
            :highlightedText="highlightedTextTimePracticeMode"
            :descText="descTextTimePracticeMode" />
        <FilterbarAnalyticsTimePracticeMode />
        <AnalyticsTimePracticeMode />
        <ChartAnalyticsTimePractice />
        <BtnChallenge />
        <BtnPracticeModes />
        <Navbar />
    </div>
</template>
<script>
    import HeaderAnalyticsPractice from '@/components/HeaderAnalyticsPractice.vue';
    import HeadingAnalyticsPractice from '@/components/HeadingAnalyticsPractice.vue';
    import AnalyticsPracticeStreak from '@/components/AnalyticsPracticeStreak.vue';
    import FilterbarAnalyticsPracticeStreak from '@/components/FilterbarAnalyticsPracticeStreak.vue';
    import AnalyticsNumPracticeComparative from '@/components/AnalyticsNumPracticeComparative.vue';
    import FilterbarAnalyticsNumPracticeMode from '@/components/FilterbarAnalyticsNumPracticeMode.vue';
    import AnalyticsNumPracticeMode from '@/components/AnalyticsNumPracticeMode.vue';
    import ChartAnalyticsNumPractice from '@/components/ChartAnalyticsNumPractice.vue';
    import FilterbarAnalyticsTimePracticeMode from '@/components/FilterbarAnalyticsTimePracticeMode.vue';
    import AnalyticsTimePracticeMode from '@/components/AnalyticsTimePracticeMode.vue';
    import ChartAnalyticsTimePractice from '@/components/ChartAnalyticsTimePractice.vue';
    import BtnChallenge from '@/components/BtnChallenge.vue';
    import BtnPracticeModes from '@/components/BtnPracticeModes.vue';
    import Navbar from '@/components/Navbar.vue';
    
    export default {
        components: {
            HeaderAnalyticsPractice,
            HeadingAnalyticsPractice,
            FilterbarAnalyticsPracticeStreak,
            AnalyticsPracticeStreak,
            AnalyticsNumPracticeComparative,
            FilterbarAnalyticsNumPracticeMode,
            AnalyticsNumPracticeMode,
            ChartAnalyticsNumPractice,
            FilterbarAnalyticsTimePracticeMode,
            AnalyticsTimePracticeMode,
            ChartAnalyticsTimePractice,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        computed: {
            highlightedTextPracticeStreak(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Haftalık';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Aylık';
                }
            },
            
            descTextPracticeStreak(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Bu yıl içinde en çok pratik yaptığın hafta.';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Bu yıl içinde en çok pratik yaptığın ay.';
                }
            },

            highlightedTextNumPracticeMode(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.numPracticeMode.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Haftalık';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Aylık';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'Yıllık';
                }
            },

            descTextNumPracticeMode(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.numPracticeMode.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Bu hafta yaptığın pratiklerin sayısı.';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Bu ay yaptığın pratiklerin sayısı.';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'Bu yıl yaptığın pratiklerin sayısı.';
                }
            },

            highlightedTextTimePracticeMode(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.timePracticeMode.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Haftalık';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Aylık';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'Yıllık';
                }
            },

            descTextTimePracticeMode(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.timePracticeMode.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Bu hafta tamamladığın pratiklerde harcadığın süre';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Bu ay tamamladığın pratiklerde harcadığın süre';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'Bu yıl tamamladığın pratiklerde harcadığın süre';
                }
            }
        }
    };
</script>
<style scoped src="@/css/views/view-analytics-practice.css"></style>